import { env } from '@/env';
import type { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router';

export default async function lineBinding({
  to,
  from,
  next,
  router
}: {
  to: RouteLocationNormalized;
  from: RouteLocationNormalized;
  next: NavigationGuardNext;
  router: Router;
}) {
  const user = useUserStore();
  const { line_binding_uid } = from.query;
  const { line_login } = to.query;

  if (!Array.isArray(line_binding_uid) && line_binding_uid) {
    const res = await fetch(`${env.apiBaseUrl}/LineBinding/BindingLineWithFundayMember`,{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.token}`
      },
      body: JSON.stringify({
        lineUserId: line_binding_uid
      })
    })

    if (res.ok) {
      window.location.href = `https://line.me/R/ti/p/${import.meta.env.VITE_LINE_OA_ID}`;
    }
  }

  if (!Array.isArray(line_login) && line_login) {
    const res = await fetch(`${env.apiBaseUrl}/Auth/LoginWithLineId`,{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        lineUserId: line_login
      })
    })

    if (res.ok) {
      const data = await res.json()
      user.token = data.content;
      user.isLogin = true;
      user.isFirstLogin = true;
    }
  }

  return next();
}
